/* pdp-delivery.js */

(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Add N (business) days to a date */
  function addDays(base, days, skipWeekends) {
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends && (d.getDay() === 0 || d.getDay() === 6)) continue;
      added++;
    }
    if (skipWeekends) {
      if (d.getDay() === 6) d.setDate(d.getDate() + 2);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    return d;
  }

  /* Bulgarian weekday + date — uses browser i18n, no hardcoded names */
  function formatBg(date) {
    var day = new Intl.DateTimeFormat('bg-BG', { weekday: 'long' }).format(date);
    var num = date.getDate();
    var mon = new Intl.DateTimeFormat('bg-BG', { month: 'long' }).format(date);
    return day + ', ' + num + ' ' + mon;
  }

  /* Trigger a single CSS tick-flash on the timer element */
  function flashTick(el) {
    el.classList.remove('pdp-dl-tick');
    void el.offsetWidth; /* force reflow so animation restarts */
    el.classList.add('pdp-dl-tick');
  }

  function initEl(el) {
    /* Prevent double-init on the same element reference */
    if (el._pdpCdActive) return;
    el._pdpCdActive = true;

    var durSec      = parseInt(el.getAttribute('data-pdp-cd-dur'),       10) || 5400;
    var days        = parseInt(el.getAttribute('data-pdp-cd-days'),      10) || 1;
    var skipWknd    = el.getAttribute('data-pdp-cd-skip-wknd') === 'true';
    var expiredText = el.getAttribute('data-pdp-cd-expired') || '';
    var pid         = el.getAttribute('data-pdp-cd-product') || 'default';

    var timerEl = el.querySelector('[data-pdp-cd-timer]');
    var dateEl  = el.querySelector('[data-pdp-cd-date]');
    if (!timerEl) return;

    /* Fill delivery date immediately (always today + N days) */
    if (dateEl) {
      var delivery = addDays(new Date(), days, skipWknd);
      dateEl.textContent = formatBg(delivery);
    }

    /* Session-persistent end time — same countdown survives page refresh */
    var KEY = '_24dx_cd_' + pid;
    var now = Date.now();
    var endTime;

    try {
      var raw = sessionStorage.getItem(KEY);
      var stored = raw ? JSON.parse(raw) : null;
      if (stored && stored.end > now) {
        endTime = stored.end;
      } else {
        endTime = now + durSec * 1000;
        sessionStorage.setItem(KEY, JSON.stringify({ end: endTime }));
      }
    } catch (e) {
      endTime = now + durSec * 1000;
    }

    var urgentThreshold = 5 * 60; /* 5 minutes in seconds */
    var tickId;

    function tick() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

      if (remaining === 0) {
        timerEl.textContent = expiredText || '00:00:00';
        el.classList.add('pdp-dl-countdown--expired');
        el.classList.remove('pdp-dl-countdown--urgent');
        clearTimeout(tickId);
        return;
      }

      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;

      var display = h > 0
        ? pad(h) + ' ч : ' + pad(m) + ' м : ' + pad(s) + ' с'
        : pad(m) + ' м : ' + pad(s) + ' с';

      timerEl.textContent = display;
      flashTick(timerEl);

      if (remaining <= urgentThreshold) {
        el.classList.add('pdp-dl-countdown--urgent');
      } else {
        el.classList.remove('pdp-dl-countdown--urgent');
      }

      /* Schedule next tick aligned to the next whole second */
      var msLeft = (endTime - Date.now()) % 1000;
      if (msLeft <= 0) msLeft += 1000;
      tickId = setTimeout(tick, msLeft);
    }

    tick();
  }

  function run() {
    document.querySelectorAll('[data-pdp-cd]').forEach(function (el) {
      /* On section reload the element is new — clear the flag */
      el._pdpCdActive = false;
      initEl(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load',    run);
  document.addEventListener('shopify:section:reorder', run);

}());
